export default [
  {
    title:  'FIELD_SERVICES_TITLE',
    icon: 'ToolIcon',
    name:'fieldServices.installation.list',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'FIELD_SERVICES_INSTALLATION_TITLE',
        name: 'fieldServices.installation.list',
        route: 'fieldServices.installation.list',
        icon: 'ToolIcon',
        meta: {
          module: 'fieldServices.installation'
        }
      }
    ],
  },
]
